// firebase deploy --only hosting:spaceflight

import React, {useEffect} from 'react';
import './App.css';

import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Header from './component/Header';

import Login from './component/login/Login'

import { useStateValue } from './utils/provider/StateProvider';
import { db, auth } from './utils/db/Authorize';

import {
  onAuthStateChanged,
} from "firebase/auth";


import { getFirestore, collection, addDoc, getDocs, doc, getDoc, onSnapshot } from "firebase/firestore";
import SpaceApp from './component/SpaceApp';
import PlanetView from './component/build/PlanetView';
import UniverseApp from './universe/UniverseApp';


function App() {
   // REDUX STATES:
  const [{user}, dispatch] = useStateValue();



  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      if(authUser){

        console.log("Loading application...", authUser)
        dispatch({
          type: 'ADD_USER',
          user: authUser
        })


        console.log("running App")
        const org = onSnapshot(collection(db, authUser.email, "data", 'organizationList'), (snapshot) => {
          let orgList = []
            snapshot.docs.forEach((doc) => {
                const data = doc.data()
                data['org_docId'] = doc.id
                orgList.push(data)
                // console.log(orgList)

                dispatch({
                  type: 'SET_ORGLIST',
                  orgList: orgList
                })
            })
        })

      }
    })
  }, [])


  return (
    <Router>
      <div className="App">
        <Routes>
          

          <Route path="/" element={<>
            <Header className="add_space"/>
            <UniverseApp/>
            
          </>}>
          </Route>

          <Route path="/u/solarsystem" element={<>
            <Header className="add_space"/>
            <SpaceApp/>
            
          </>}>
          </Route>

          <Route path="/u/bodies/:planet" element={<>
            <Header />
            <PlanetView />

          </>}>
          </Route>

          <Route path="/u/login" element={<>
            <Header />
            <Login />

          </>}>
          </Route>

          <Route path="/u/universe" element={<>
            <Header />
            <UniverseApp/>

          </>}>
          </Route>

          
            
        </Routes>
      </div>
    </Router>
  );
}

export default App;
